// custom typefaces
import "typeface-merriweather"
import "typeface-montserrat"
import { posthogAnalytics } from "./src/posthogAnalytics"

// Prism theme
require("prismjs/themes/prism.css")

// Fire a PostHog pageview on every client-side route change. The initial page
// load is also reported here (Gatsby calls onRouteUpdate for it too).
export const onRouteUpdate = ({ location }) => {
  posthogAnalytics.pageView(location.pathname)
}
